module.exports = __webpack_public_path__ + "b5d27cbb5cc6c0704930dad428d2469b.png";